export default "/assets/images/home-wrecker-modal.png?9fcfb5faeb38910cd10a078081f21bf1";